



















import ApiClient from '@/js/api.js'
import PointBadge from '@/views/molecules/PointBadge.vue'

export default
  components: {
    PointBadge
  }

  props:
    title:
      type: Array
      default: []
    subtitle:
      type: Array
      default: []
    message:
      type: Array
      default: []
    point_code:
      type: String
    main_image:
      type: String
    mode_simple:
      type: Boolean
      default: false

  data: () ->
    point: 0

  mounted: () ->
    document.querySelector('html, body').style.overflowY = 'hidden'
    document.querySelector('.scroll_area').addEventListener('scroll', @scroll)
    document.querySelector('#section_flow').style.display = 'none'

    api = new ApiClient()
    param =
      'point_code': @point_code
    data = await api.post('/member/point/save', true, param)
    @point = data.point
    if @point > 0
      @$emit('addPoint', @point)
  beforeDestroy: () ->
    document.querySelector('#section_flow').style.display = 'block'
    document.querySelector('html, body').style.overflowY = 'scroll'
    if window.innerWidth > 750
      document.querySelector('#section_flow').style.display = 'flex'

  methods:
    popupClose: () ->
      @$emit('closePopup')
